import { optional, array, obj, required } from 'AppReact/schema';

const order = {
  assigned_to: optional('string'),
  category_name: optional('string'),
  completed_at: optional('jsDate'),
  id: required('integer'),
  inserted_at: optional('jsDate'),
  parent_category_name: optional('string'),
  reopening: optional('string'),
  status: required('string'),
  ticket: optional('string')
}

export default {
  cancelled_orders: array(obj(order)),
  completed_orders: array(obj(order)),
  open_orders: array(obj(order)),
  id: optional('integer'),
};